export enum OfferState {
  Active = "active",
  Expired = "expired",
  Scheduled = "scheduled",
  Disabled = "disabled",
}

export enum OfferDiscountType {
  Percentage = "percentage",
  Value = "value",
}

export enum OfferTargetType {
  ProductsIds = "product_ids",
  AllProducts = "all_products",
  CategoryIds = "category_ids",
  AllCategories = "all_categories",
}

export enum OfferSelectionType {
  Products = "products",
  Categories = "categories",
}

export enum OfferMode {
  Bulk = "bulk",
  Individual = "individual",
}

export enum OfferWizardStep {
  Selector = "selector",
  Discount = "discount",
  Form = "form",
}

export enum OfferProductStatus {
  None = "none",
  Inactive = "inactive",
  SoldOut = "sold_out",
  ActiveOffer = "active_offer",
}

export const OFFER_FILTER_OPTIONS = [
  OfferState.Active,
  OfferState.Expired,
  OfferState.Scheduled,
  OfferState.Disabled,
] as const;
